export default function PageError() {
  throw new Error("You found the error page")
}